import { moduleDelays } from "./utils";
import { $, body } from "@utils/dom";
import { on, off } from "@utils/listener";

const SELECTOR = "[data-site-loader]";

class SiteLoader {
  constructor() {
    this.el = $(SELECTOR);
    
    this._readyPromise = null;
    this._onAnimateOutCompleted = this._onAnimateOutCompleted.bind(this);
  }

  loaded() {
    moduleDelays(350, 550);
  }

  ready() {
    return new Promise(resolve => {
      this._readyPromise = resolve;

      on(this.el, 'animationend', this._onAnimateOutCompleted);
      this.el.classList.add('--animate-out');
    });
  }

  _onAnimateOutCompleted(event) {
    // make sure event is triggered by .site-loader
    if( event.target !== this.el ) return;

    off(this.el, 'animationend', this._onAnimateOutCompleted);

    // remove from DOM when completed
    if( this.el ) this.el.remove();

    // add class on body when transition is ready
    body.classList.add("--js-ready");

    // resolve transition
    this._readyPromise();
    this._readyPromise = null;
  }
}

export default SiteLoader;
